import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserData } from '../redux/actions/ActionsUserData';
import MyStorage from '../store/MyStorage';

const TIMEOUT_DURATION = 30 * 60 * 1000; // 30 minutos

const handleLogout = (dispatch) => {
    console.log("Sesión cerrada por inactividad.");
    localStorage.removeItem('lastActivity');
    new MyStorage().setUserInfo(null);
    dispatch(setUserData(null));
    alert("Sesión cerrada por inactividad.");
    window.location = '/';
};

// Esta función se ejecuta tan pronto como el módulo se carga.
const checkAndHandleTimeoutOnLoad = (dispatch) => {
    const lastActivity = localStorage.getItem('lastActivity');
    const currentTime = new Date().getTime();

    if (lastActivity && currentTime - parseInt(lastActivity, 10) > TIMEOUT_DURATION) {
        handleLogout(dispatch);
    }
};

const SessionManager = () => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.user_data.user);

    // Llama a la función de verificación al cargar el componente
    checkAndHandleTimeoutOnLoad(dispatch);

    const handleUserActivity = useCallback(() => {
        const lastActivity = localStorage.getItem('lastActivity');
        const currentTime = new Date().getTime();

        if (lastActivity && currentTime - parseInt(lastActivity, 10) > TIMEOUT_DURATION) {
            handleLogout(dispatch);
        } else {
            localStorage.setItem('lastActivity', currentTime);
        }
    }, [dispatch]);

    useEffect(() => {
         // 🔥 LINEA AGREGADA
        // Cierra la sesión si no existe la clave 'lastActivity' en localStorage
        if (!localStorage.getItem('lastActivity') && userData) {
             handleLogout(dispatch);
             return; // Detiene la ejecución del resto del useEffect
        }
        if (userData) {
            // Actualiza el timestamp si hay actividad y el usuario está logueado
            localStorage.setItem('lastActivity', new Date().getTime());
        }

        const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];

        events.forEach(event => {
            window.addEventListener(event, handleUserActivity);
        });

        // Limpia los listeners al desmontar el componente
        return () => {
            events.forEach(event => {
                window.removeEventListener(event, handleUserActivity);
            });
        };
    }, [handleUserActivity, userData]);

    return null;
};

export default SessionManager;